import { makeStyles,useTheme } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme =>({
  wrapper: {
    margin: '30px 0',
    [theme.breakpoints.down('sm')]: {
      margin:'20px 20px 0px 20px'
    }
  },
  title: {
    margin: '0 0 12px',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
       alignItems: 'center',
      justifyContent: 'center',
    }
  },
  inputIndent: {
    marginBottom: '30px',
    [theme.breakpoints.down('sm')]: {
     
      padding: '0px 20px 0px 20px',
      alignItems: 'flex-center',
    }
  },
  labelWithHelpIcon: {
    display: 'flex',
    position: 'relative'
  },
  helpIcon: {
    position: 'absolute',
    fontSize: '18px',
    top: '-4px',
    marginLeft: '6px'
  }
}));
